import React from 'react';
import PropTypes from 'prop-types';
import {
  injectIntl,
  defineMessages,
} from 'gatsby-plugin-react-intl';
import { intlShape } from '@prospectus/common/types/intlShape';
import CloudflareImage from '@prospectus/common/ui/CloudflareImage';
import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';

function CoursePartnerLogos({
  intl,
  partners,
}) {
  const logoImageParams = {
    width: 200, height: 101, quality: 75, format: 'webp',
  };
  const messages = defineMessages({
    'prospectus.course.header.logo': {
      id: 'prospectus.course.header.logo',
      defaultMessage: '{partnerName} Logo',
      description: 'This is alt text for a partner\'s logo image',
    },
  });

  return (
    <div className="mt-2.5 mt-sm-3 mb-2">
      {partners.map(partner => (
        !partner?.tags?.includes('build-as-preview') && partner?.tags?.includes('displayed_on_schools_and_partners_page') && partner?.marketingUrl ? (
          <ProspectusLink
            className="course-org-link d-inline-block mr-4"
            href={`school/${partner.slug.toLowerCase()}`}
            key={partner.marketingUrl}
            analytics={{
              eventName: 'edx.bi.user.course.partners.click',
            }}
          >
            <CloudflareImage
              url={partner.logoImageUrl}
              title={intl.formatMessage(
                messages['prospectus.course.header.logo'],
                { partnerName: partner.name },
              )}
              additionalParams={logoImageParams}
              className="course-org-logo"
            />
          </ProspectusLink>
        ) : (
          <div className="d-inline-block">
            <CloudflareImage
              url={partner.logoImageUrl}
              title={intl.formatMessage(
                messages['prospectus.course.header.logo'],
                { partnerName: partner.name },
              )}
              additionalParams={logoImageParams}
              className="course-org-logo"
            />
          </div>
        )
      ))}
    </div>
  );
}

CoursePartnerLogos.propTypes = {
  intl: intlShape.isRequired,
  partners: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string,
    slug: PropTypes.string,
    name: PropTypes.string,
    logoImageUrl: PropTypes.string,
    marketingUrl: PropTypes.string,
  })).isRequired,
};

export default injectIntl(CoursePartnerLogos);
